import { staticPage } from "grandus-lib/utils/fetches";
import styles from "./static.page.module.scss";
import ErrorPage from "next/error";
import MetaData from "grandus-lib/components-atomic/MetaData";

import dynamic from "next/dynamic";
import CustomGaEvent from "utils/CustomGaEvent";
const Image = dynamic(() =>
  import("grandus-lib/components-atomic/image/Image")
);

const StaticPage = (props) => {
  const { page } = props;
  const {
    id = false,
    title = "",
    customCss = "",
    customJavascript = "",
    content = "",
    photo = false,
  } = page ? page : {};

  if (!id) {
    return <ErrorPage statusCode={404} />;
  }

  const meta = {
    title: page?.title,
    photo: page?.photo ? page?.photo : {},
  };

  return (
    <div className={`container guttered ${styles.wrapper}`}>
      <CustomGaEvent page={"Static page"} />
      <MetaData {...meta} />
      {customCss ? (
        <style
          dangerouslySetInnerHTML={{
            __html: customCss,
          }}
        />
      ) : null}
      <h1>{title}</h1>
      {photo ? (
        <Image
          className={styles.mainImage}
          photo={photo}
          size={"1100x600"}
          type={"jpg"}
          useNextImage={true}
          priority={true}
        />
      ) : (
        ""
      )}
      <div
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
      {customJavascript ? (
        <div
          dangerouslySetInnerHTML={{
            __html: customJavascript,
          }}
        />
      ) : null}
    </div>
  );
};

export async function getServerSideProps(context) {
  return staticPage.serverSideProps(context);
}

export default StaticPage;
